// extracted by mini-css-extract-plugin
module.exports = {"task-card":"task-list_task-card__MtE0r"};